import { Controller } from "@hotwired/stimulus"

// Shows the block belonging to the selected payment method on the sign-off step.
//
// Comfort only — WizardController#complete re-checks the choice and everything
// it requires, because a radio the browser never rendered is not a guarantee.
export default class extends Controller {
  static targets = ["sepaRadio", "sepaPanel", "invoicePanel"]

  choose() {
    const sepa = this.hasSepaRadioTarget && this.sepaRadioTarget.checked

    this.toggle(this.sepaPanelTarget, sepa)
    this.toggle(this.invoicePanelTarget, !sepa)

    // Focus the first field of the block that just opened, so choosing SEPA
    // lands the cursor in Kontoinhaber rather than leaving it on the radio.
    const opened = sepa ? this.sepaPanelTarget : this.invoicePanelTarget
    opened.querySelector("input:not([type=hidden]), select, textarea")?.focus()
  }

  toggle(panel, visible) {
    if (panel) panel.classList.toggle("hidden", !visible)
  }
}
